import { useRef, useCallback } from "react";
import { Animated, Dimensions, Easing } from "react-native";

export const useAnimateTransition = () => {
  const screenWidth = Dimensions.get('window').width;
  const slideAnim = useRef(new Animated.Value(0)).current;
  const fadeAnim = useRef(new Animated.Value(1)).current;
  const isAnimating = useRef(false);

  const animateStepTransition = useCallback((direction: 'forward' | 'backward', callback: () => void) => {
    if (isAnimating.current) return;

    isAnimating.current = true;
    const slideDistance = direction === 'forward' ? -screenWidth * 0.3 : screenWidth * 0.3;

    Animated.parallel([
      Animated.timing(slideAnim, {
        toValue: slideDistance,
        duration: 200,
        easing: Easing.bezier(0.4, 0.0, 0.2, 1),
        useNativeDriver: true,
      }),
      Animated.timing(fadeAnim, {
        toValue: 0,
        duration: 150,
        easing: Easing.out(Easing.quad),
        useNativeDriver: true,
      })
    ]).start(() => {
      const enterFromDistance = direction === 'forward' ? screenWidth * 0.3 : -screenWidth * 0.3;
      slideAnim.setValue(enterFromDistance);
      fadeAnim.setValue(0);
      callback();

      setTimeout(() => {
        Animated.parallel([
          Animated.timing(slideAnim, {
            toValue: 0,
            duration: 250,
            easing: Easing.bezier(0.0, 0.0, 0.2, 1),
            useNativeDriver: true,
          }),
          Animated.timing(fadeAnim, {
            toValue: 1,
            duration: 200,
            easing: Easing.out(Easing.quad),
            useNativeDriver: true,
          })
        ]).start(() => {
          isAnimating.current = false;
        });
      }, 16);
    });
  }, [slideAnim, fadeAnim, screenWidth]);

  return {
    animateStepTransition,
    slideAnim,
    fadeAnim,
  }
}